<div class="ai-loader-container" *ngIf="!genearateSuccess">
    <!-- AI Brain Animation removed as requested -->

    <!-- Floating Question Marks -->
    <div class="floating-elements">
        <div class="question-mark">?</div>
        <div class="question-mark">?</div>
        <div class="question-mark">?</div>
        <div class="question-mark">?</div>
    </div>

    <!-- Floating Code Symbols for Coding Questions -->
    <div class="floating-code-symbols" *ngIf="displayText.toLowerCase().includes('coding')">
        <div class="code-symbol">{{ '{' }}</div>
        <div class="code-symbol">{{ '}' }}</div>
        <div class="code-symbol">&lt;/&gt;</div>
        <div class="code-symbol">;</div>
    </div>

    <!-- Progress Ring -->
    <div class="progress-ring">
        <svg class="progress-ring-svg" width="120" height="120">
            <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" style="stop-color:#3b82f6;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#10b981;stop-opacity:1" />
                </linearGradient>
            </defs>
            <circle class="progress-ring-circle-bg" cx="60" cy="60" r="54"></circle>
            <circle class="progress-ring-circle" cx="60" cy="60" r="54"
                [style.strokeDashoffset]="getProgressRingOffset()"></circle>
        </svg>
        <div class="progress-text">
            <span class="progress-percentage">{{progressPercentage | number:'1.0-0'}}%</span>
            <span class="progress-label">Generating</span>
        </div>
    </div>

    <!-- AI Processing Lines -->
    <div class="processing-lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>

    <!-- Sparkle Effects -->
    <div class="sparkles">
        <div class="sparkle" *ngFor="let i of [1,2,3,4,5,6]"></div>
    </div>
</div>

<div *ngIf="genearateSuccess" class="success-container">
    <div class="success-checkmark">
        <div class="check-icon">
            <span class="check-line check-line--long"></span>
            <span class="check-line check-line--short"></span>
        </div>
    </div>
</div>

<div class="text {{reGenerate ? 're-generate-text' :''}} {{genearateSuccess ? 'success-text' : 'generate-text'}}">
    <span *ngIf="!genearateSuccess">{{typedText}}<span class="typing-cursor">|</span></span>
    <span *ngIf="genearateSuccess">{{displayText}}</span>
</div>